import { useState } from "react";
import HttpClient from "../utils/HttpClient";

const MemberVideoUpdateModal = ({ closemodal, data, setData, updateForm, setSaveEditedData }) => {
  const [formData, setFormData] = useState(data);
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState({});
  const initDoc = {
    "docName": "",
    "pdf": "",
    "fileName": ""
  }

  const validate = () => {
    let isValid = true;
    const error = {};

    if (!formData?.videoUrl) {
      error.videoUrl = "Please enter video URL";
      isValid = false;
    }

    setErrors(error);
    return isValid;
  };

  const submit = () => {
    if (validate()) {
      setData({
        ...data,
        ...formData,
      });
      setSaveEditedData(true);
      closemodal();
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({ ...prevData, [field]: value }));
  };

  // const handleDocumentName = (e, i) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => {
  //     const newData = [...prev.doc];
  //     newData[i] = { ...newData[i], [name]: value };
  //     return { ...prev, doc: newData };
  //   });
  // }

  // const handleDocument = async (e, i) => {
  //   let formData = new FormData()
  //   const file = e.target.files[0];
  //   if (!file) return;
  //   // Validate file type
  //   const validFileTypes = ["application/pdf"];
  //   if (!validFileTypes.includes(file.type)) {
  //     setErrors(prev => ({ ...prev, [`pdf_${i}`]: "Error: Please upload a valid PDF file" }));
  //     return;
  //   }

  //   // Validate file size (3MB = 3145728 bytes)
  //   const maxSize = 3 * 1024 * 1024;
  //   if (file.size > maxSize) {
  //     setErrors(prev => ({ ...prev, [`pdf_${i}`]: "Error: File size must be less than or equal to 3MB" }));
  //     return;
  //   }
  //   // console.log("Selected file:", file);
  //   // console.log("selected index:", i);
  //   setSelectedFile(prev => ({ ...prev, [`pdf_${i}`]: file?.name || '' }));
  //   // console.log("Selected file:", selectedFile);
  //   formData.append("document", e.target.files[0])
  //   const res = await HttpClient.fileUplode("document-upload", "POST", formData);
  //   if (res && res.status) {
  //     setFormData((prevData) => {
  //       const newDocData = [...prevData.doc];
  //       newDocData[i] = { ...newDocData[i], pdf: res.data.url, fileName: file?.name || '' };
  //       return { ...prevData, doc: newDocData };
  //     });
  //     setErrors(prev => {
  //       const newErrors = { ...prev };
  //       delete newErrors[`pdf_${i}`];
  //       return newErrors;
  //     });
  //   } else {
  //     setErrors(prev => ({ ...prev, [`pdf_${i}`]: res?.message || "Error uploading file" }));
  //   }
  // }

  // const handleAddMore = () => {
  //   const newData = [...formData.doc, { ...initDoc }];
  //   setFormData(prev => ({ ...prev, doc: newData }));
  // }

  return (

    <div className="uploabannermodalbgshadow">
      <div className="compamyinfoeditbgmain">
        <h5 className="mt-2 p-0 m-3">Update Profile</h5>
        <hr />
        <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <div className="modal-body-x">
          <div className="modal-form-container">
            <div className="compamydinfodivmain">

              <div className="compamydinfodivmainbtm">
                <p className="conattaindptxtppnewallasa">
                  Video URL <span>*</span>
                </p>
                <input
                  type="text"
                  placeholder="Video URL"
                  className="inpustxocntbusuitxtppnewallattyy"
                  value={formData?.videoUrl || ""}
                  onChange={(e) =>
                    handleInputChange("videoUrl", e.target.value)
                  }
                />
                {errors.videoUrl && (
                  <span className="error">{errors.videoUrl}</span>
                )}
              </div>
            </div>
          </div>


          <div className="eidutcommhifnnfodiv mt-2">
            <div className="svavtatvvbtnnmddsupscftt">
              <button
                className="svavtatvvbtnnm"
                onClick={() => {
                  submit();
                }}
              >
                Save
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
export default MemberVideoUpdateModal;
